import { useEffect, useState } from 'react';
import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

// Shared municipality -> sub-municipality -> suco cascading dropdown logic,
// previously duplicated across every Road Safety Condition data-entry form.
export default function useMunicipalityCascade() {
  const [municipalities, setMunicipalities] = useState([]);
  const [subMunicipalities, setSubMunicipalities] = useState([]);
  const [sucos, setSucos] = useState([]);
  const [selectedMunicipality, setSelectedMunicipality] = useState('');
  const [selectedSubMunicipality, setSelectedSubMunicipality] = useState('');
  const [selectedSuco, setSelectedSuco] = useState('');

  useEffect(() => {
    axios.post(`${backendUrl}Municipalities/municipalities_list/`)
      .then((response) => setMunicipalities(response.data))
      .catch((error) => console.error('Error fetching municipalities:', error));
  }, []);

  useEffect(() => {
    if (selectedMunicipality) {
      axios.post(`${backendUrl}Municipalities/sub_municipalities_list/`, { adm2_code: selectedMunicipality })
        .then((response) => setSubMunicipalities(response.data))
        .catch((error) => console.error('Error fetching sub-municipalities:', error));
    } else {
      setSubMunicipalities([]);
      setSucos([]);
    }
  }, [selectedMunicipality]);

  useEffect(() => {
    if (selectedSubMunicipality) {
      axios.post(`${backendUrl}Municipalities/suco_list/`, { adm2_code: selectedSubMunicipality })
        .then((response) => setSucos(response.data))
        .catch((error) => console.error('Error fetching sucos:', error));
    } else {
      setSucos([]);
    }
  }, [selectedSubMunicipality]);

  const handleMunicipalityChange = (e) => {
    setSelectedMunicipality(e.target.value);
    setSelectedSubMunicipality('');
    setSelectedSuco('');
  };

  const handleSubMunicipalityChange = (e) => {
    setSelectedSubMunicipality(e.target.value);
    setSelectedSuco('');
  };

  const handleSucoChange = (e) => {
    setSelectedSuco(e.target.value);
  };

  // Sets the cascade directly from a resolved adm hierarchy (lat/lon reverse
  // lookup) rather than a manual dropdown pick. Reuses the same setters as
  // the manual handlers, so the existing sub-municipality/suco fetch effects
  // still fire normally.
  const applyResolvedAdm = (adm1Code, adm2Code, adm3Code) => {
    setSelectedMunicipality(adm1Code);
    setSelectedSubMunicipality(adm2Code);
    setSelectedSuco(adm3Code);
  };

  const reset = () => {
    setSelectedMunicipality('');
    setSelectedSubMunicipality('');
    setSelectedSuco('');
    setSucos([]);
  };

  return {
    municipalities,
    subMunicipalities,
    sucos,
    selectedMunicipality,
    selectedSubMunicipality,
    selectedSuco,
    handleMunicipalityChange,
    handleSubMunicipalityChange,
    handleSucoChange,
    applyResolvedAdm,
    reset,
  };
}
